import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { classes as multiClasses } from '../../event-list/js/event-list';
/**
 * product-finder-teaser module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */

const classes = {
	filter: 'm-product-finder-teaser-V2__filterwrapper',
	filterTag: 'm-product-finder-teaser-V2__filter-tag',
	filterTags: 'm-product-finder-teaser-V2__filter-tags',
	filterTagContainer: 'm-product-finder-teaser-V2__filter-tags-container',
	materialSelect: 'js-m-product-finder-teaser-V2__select-material',
	countrySelect: 'js-m-product-finder-teaser-V2__select-marketswitch',
	link: 'js-m-product-finder-teaser__link',
	labelText: 'm-product-finder-teaser-V2__filter-tag-text',
	selectorTag: 'm-filter-two-level-multiselect__layer-level3',
	filterSelect: 'm-product-finder-teaser-V2__filter',
	bottomSection: 'm-product-finder-teaser-V2__bottom',
	clearFilterBtn: 'm-product-finder-teaser-V2__clear-filter'
};

@createModule('ProductFinderTeaserV2')
export class ProductFinderTeaser extends TerrificSpec {
	$ctx: JQuery;
	data: any;
	$form: JQuery;
	$link: JQuery;
	$paramValues: any;
	$hiddenFieldTest: JQuery;
	$hiddenFieldValues: JQuery;


	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.data = this.$ctx.data();
		this.$form = $('.js-m-product-finder-teaser-V2__form', this.$ctx);
		this.$link = $(`.${classes.link}`, this._ctx);
		this.$hiddenFieldTest = $('#hiddenLinkTestValues');
		this.$hiddenFieldValues = $('#hiddenLinkValues');
		this.$ctx.on('FilterTwoLevelMultiCheckboxChanged', this.adjustLinkUrl.bind(this));
		this.adjustLinkUrl();
		this.$ctx.find(`.${classes.selectorTag}`).on('click', this.showFilters.bind(this));
		this.$ctx.find(`.${classes.clearFilterBtn}`).on("click", this.clearAllFilters.bind(this));
		this.$ctx.find(`.${classes.link}`).on("click", this.onButtonSubmit.bind(this));
		resolve();
	}

	showFilters(event: Event) {
		event.stopPropagation();
		const checkboxes = this.$ctx.find("input:checked");
		const tagsContainer = this.$ctx.find(`.${classes.filterTagContainer}`);
		tagsContainer.empty();
		if (checkboxes.length > 0) {
			for (let i = 0; i < checkboxes.length; i++) {
				const checkbox = checkboxes.eq(i);
				const id = checkbox.attr('id');
				const label = this.$ctx.find("label[for='" + id + "']");
				const o = "<div class='m-product-finder-teaser-V2__filter-tag'><span class='m-product-finder-teaser-V2__filter-tag-text'>" + label.text() + "</span></div>";
				tagsContainer.append(o);
			}
			this.$ctx.find(`.${classes.filterTag}`).on('click', this.onCloseFilter.bind(this));
			this.$ctx.find(`.${classes.filterTags}`).show();
			this.$ctx.find(`.${classes.bottomSection}`).show();
		}
		else {
			this.clearAllFilters();
		}
	}

	onCloseFilter(event: Event) {
		event.stopPropagation();
		$(event.currentTarget).remove();
		const text = $(event.currentTarget).text();
		const checkboxes = this.$ctx.find("input:checked");

		for (let i = 0; i < checkboxes.length; i++) {
			const checkbox = checkboxes.eq(i);
			const id = checkbox.attr('id');   // get the id
			const label = this.$ctx.find("label[for='" + id + "']");  // look for matching label
			if (label.text() == text) {
				label.prev().prop('checked', false);
				if (checkboxes.length == 1) {
					this.clearAllFilters();
				}
			}

		}
		this.$ctx.find(`.${multiClasses.twoLevelList}`).removeClass(multiClasses.twoLevelListOpen);
		this.$ctx.find(`.${multiClasses.oneLevelList}`).removeClass(multiClasses.oneLevelListOpen);
	}

	clearAllFilters() {
		this.$ctx.find(`.${classes.filterSelect}`).find("input").prop('checked', false);
		this.$ctx.find(`.${classes.bottomSection}`).hide();
		this.$ctx.find(`.${classes.filterSelect}`).find(`.${multiClasses.twoLevelMainChecked}`)
			.removeClass(`${multiClasses.twoLevelMainChecked}`);
		this.$ctx.find(`.${classes.filterSelect}`).find(`.${multiClasses.twoLevelParentChecked}`)
			.removeClass(`${multiClasses.twoLevelParentChecked}`);
		this.$ctx.find(`.${classes.filterSelect}`).find(`.${multiClasses.oneLevelMainChecked}`)
			.removeClass(`${multiClasses.oneLevelMainChecked}`);
		this.$ctx.find(`.${classes.filterTagContainer}`).empty();
		this.$ctx.find(`.${classes.filterTags}`).hide();
		this.$ctx.find(`.${multiClasses.teaserContainer}`).empty();
	}

	adjustLinkUrl() {
		const separator = this.data.filterseperator || ':';
		const sortingParam = this.data.sortingparam ? separator + this.data.sortingparam : '';
		const countryParam = separator + this.data.countryparam + separator + this.data.marketparam;

		const serializedData = this.$form
			.serializeArray()
			.filter((e) => {
				return e.value !== '';
			})
			.map((e) => {
				return encodeURIComponent(e.value);
			});
		let materialAndIndustryParams = '';

		if (serializedData.length) {
			materialAndIndustryParams = separator + serializedData.join(separator);
		}

		const allParams = sortingParam + countryParam + materialAndIndustryParams;
		const newLinkUrl = this.data.baseurl;

		this.$paramValues = allParams;
		this.$link.attr('href', newLinkUrl);

	}

	onButtonSubmit() {
		localStorage.setItem("productFinderTeaserQueryParams", JSON.stringify(this.$paramValues));
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() { }
}
